import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { toSignal } from '@angular/core/rxjs-interop';
import { ActionConfig } from '@core/models/action-config.model';
import { AuthenticationService } from '@core/services/auth.service';
import { MenuItem } from 'primeng/api';
import { Avatar } from 'primeng/avatar';
import { SplitButton } from 'primeng/splitbutton';

@Component({
  selector: 'fl-fo-user-info',
  imports: [SplitButton, Avatar],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-splitbutton label="Account" [model]="menuItems()" size="small" severity="secondary">
      <ng-template #content>
        <span class="flex items-center lg:gap-2">
          <p-avatar
            size="normal"
            label="{{ userInfo()?.firstName?.charAt(0) }}{{
              userInfo()?.lastName?.charAt(0)
            }}"></p-avatar>
          <span class="flex-col items-start hidden xl:flex">
            <span>{{ userInfo()?.firstName }} {{ userInfo()?.lastName }}</span>
            <small class="text-small opacity-75">{{ userInfo()?.email }}</small>
          </span>
        </span>
      </ng-template>
    </p-splitbutton>
  `,
})
export class UserInfoComponent {
  private authService = inject(AuthenticationService);

  userInfo = toSignal(this.authService.currentUser$);
  actions = input<ActionConfig[]>([]);
  action = output<string>();
  loggedOut = output<void>();

  private toMenuItem = (a: ActionConfig): MenuItem => ({
    id: a.key,
    label: a.label,
    icon: a.icon,
    disabled: a.disabled,
    visible: typeof a.visible === 'function' ? a.visible() : a.visible !== false,
    command: () => this.action.emit(a.key),
  });

  menuItems = computed<MenuItem[]>(() => {
    const base = (this.actions() || [])
      .filter(a => (typeof a.visible === 'function' ? a.visible() : a.visible !== false))
      .map(this.toMenuItem);
    base.push({
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        this.authService.logout();
        this.loggedOut.emit();
      },
    });
    return base;
  });
}
